import './App.css';
import Footer from './Components/Footer/footer';
import Navbar from "./Components/Header/Navbar";
import { Outlet, useLocation } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from 'react-hot-toast';
import VisitorCard from './Components/floatingCardBottom/floatingCard';
import useAuthCheck from './customeHook/useAuthCheck';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 10,
      gcTime: 1000 * 60 * 10,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});


function App() {
  const location = useLocation();
  useAuthCheck();

  const hideNavbarandFooterRoutes = ["/login", "/signup"];
  const shouldHideNavbarFooter = hideNavbarandFooterRoutes.includes(location.pathname);

  return (
    <QueryClientProvider client={queryClient}>
      <div className="text-white">
        <div className="bg-cover bg-center bg-no-repeat">
          <Toaster position="top-center" reverseOrder={false} />
          {!shouldHideNavbarFooter && <Navbar />}
          <Outlet />
          {!shouldHideNavbarFooter && <Footer />}
          {!shouldHideNavbarFooter && <VisitorCard />}
        </div>
      </div>
    </QueryClientProvider>
  );
}

export default App;
